import { ComposableMap, Geographies, Geography } from 'react-simple-maps';

import { useThemes } from 'uiKit/Theme/hook/useThemes';

import map from '../../map.json';
import { Country } from '../../types';
import { getGeogrpahyStyles } from './utils/getGeographyStyles';

interface StatsMapProps {
  data: Country[];
  setCountry: (country: string) => void;
}

const ANTARCTICA = 'AQ';

export const StatsMap = ({ data, setCountry }: StatsMapProps) => {
  const { isLightTheme } = useThemes();

  return (
    <ComposableMap height={470}>
      <Geographies geography={map}>
        {({ geographies }) => {
          return geographies
            .filter(d => d.properties.ISO_A2 !== ANTARCTICA)
            .map(geo => {
              const styles = getGeogrpahyStyles({
                geo,
                data,
                isLightTheme,
              });

              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  style={styles}
                  onMouseEnter={() => {
                    if (styles.hasColor) {
                      setCountry(geo.properties.ISO_A2);
                    }
                  }}
                  onMouseLeave={() => setCountry('')}
                />
              );
            });
        }}
      </Geographies>
    </ComposableMap>
  );
};
